import React from 'react';
import { Link } from 'react-scroll';
import { FaFacebook, FaInstagram, FaTripadvisor, FaHeart, FaShoppingBag } from 'react-icons/fa';
import logo from './logo.png';
import { useCart } from '../context/CartContext';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  const { openCart } = useCart();

  const quickLinks = ['Home', 'About', 'Menu', 'Gallery', 'Contact'];
  const menuHighlights = [
    'Doner Kebab',
    'Chicken Tikka Kebab',
    'Chicken Tikka Masala',
    'King Special Pizza',
    'Chicken Fillet Burger',
    'Chicken Goujon Kebab',
  ];

  return (
    <footer className="footer">
      {/* Top CTA Band */}
      <div className="footer-cta-band">
        <div className="container footer-cta-inner">
          <div className="footer-cta-text">
            <h3 className="footer-cta-title">Hungry? Order Takeaway Now</h3>
            <p className="footer-cta-sub">Fresh, flame-grilled food ready for collection or delivery · Athlone &amp; surrounding areas</p>
          </div>
          <button onClick={openCart} className="btn-primary footer-cta-btn" id="footer-order-btn">
            <FaShoppingBag />
            <span>Order Now</span>
          </button>
        </div>
      </div>

      {/* Main Footer */}
      <div className="footer-main">
        <div className="container footer-grid">

          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="King Kebab Logo" className="footer-logo-img" />
              <div>
                <span className="footer-logo-name">King Kebab</span>
                <span className="footer-logo-sub">Athlone, Co. Westmeath</span>
              </div>
            </div>
            <p className="footer-brand-desc">
              Athlone's favourite takeaway since 2009 — serving authentic kebabs,
              juicy burgers, stone-baked pizzas and rich Indian curries with heart.
            </p>
            {/* Social */}
            <div className="footer-socials">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-link" aria-label="Facebook" id="footer-facebook">
                <FaFacebook />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-link" aria-label="Instagram" id="footer-instagram">
                <FaInstagram />
              </a>
              <a href="https://tripadvisor.com" target="_blank" rel="noreferrer" className="social-link" aria-label="TripAdvisor" id="footer-tripadvisor">
                <FaTripadvisor />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link}>
                  <Link
                    to={link.toLowerCase()}
                    smooth
                    duration={600}
                    offset={-80}
                    className="footer-link"
                  >
                    <span className="footer-link-arrow">›</span>
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Menu Highlights */}
          <div className="footer-col">
            <h4 className="footer-col-title">Popular Items</h4>
            <ul className="footer-links">
              {menuHighlights.map((item) => (
                <li key={item}>
                  <span className="footer-menu-item">
                    <span className="footer-link-arrow">›</span>
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-col">
            <h4 className="footer-col-title">Find Us</h4>
            <div className="footer-contact-list">
              <div className="footer-contact-item">
                <span className="fci-label">Address</span>
                <span className="fci-value">10 Sean Costello Street<br />Irishtown, Athlone<br />Co. Westmeath, Ireland</span>
              </div>
              <div className="footer-contact-item">
                <span className="fci-label">Order / Call</span>
                <span className="fci-value">+353 90 645 0000</span>
              </div>
              <div className="footer-contact-item">
                <span className="fci-label">Email</span>
                <span className="fci-value">info@kingkebab.ie</span>
              </div>
              <div className="footer-contact-item">
                <span className="fci-label">Hours</span>
                <span className="fci-value">Mon–Sun: Open from 4:00 PM</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p className="footer-copy">
            © {year} King Kebab – Athlone, Co. Westmeath. All rights reserved.
          </p>
          <p className="footer-made">
            Made with <FaHeart className="heart-icon" /> for great food
          </p>
          <div className="footer-legal">
            <a href="#privacy" className="footer-legal-link">Privacy Policy</a>
            <span className="footer-legal-sep">·</span>
            <a href="#terms" className="footer-legal-link">Terms &amp; Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
